// src/utils/money.ts
/**
 * Format an integer amount in cents into a localized currency string.
 * Always pass cents. This keeps FE aligned with backend "cents" contract.
 */
export function formatMoney(cents: number, currency: string = "USD"): string {
  const value = typeof cents === "number" && Number.isFinite(cents) ? cents / 100 : 0;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  } catch {
    // Fallback if the currency code is unsupported in the current runtime
    return `${currency} ${value.toFixed(2)}`;
  }
}
